import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    id: "ghl-image-editor-element-control",
    class: "absolute hidden z-20"
};
const _hoisted_2 = { class: "flex flex-row space-x-2 px-2 py-2 bg-gray-900 rounded-md shadow-md" };
import EmitterEvents from '@/events';
import { Copy03Icon, Trash01Icon } from '@gohighlevel/ghl-icons/24/outline';
import { UITooltip } from '@gohighlevel/ghl-ui';
import { inject } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIElementControls',
    setup(__props) {
        const emitter = inject('emitter');
        function cloneElement() {
            // Emit Event
            emitter.emit(EmitterEvents.IMAGE_EDITOR_CONTROLS_CLONE);
        }
        function deleteElement() {
            // Emit Event
            emitter.emit(EmitterEvents.IMAGE_EDITOR_CONTROLS_DELETE);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(UITooltip), { placement: "top" }, {
                        trigger: _withCtx(() => [
                            _createVNode(_unref(Copy03Icon), {
                                class: "w-5 h-6 text-white cursor-pointer",
                                onClick: cloneElement
                            })
                        ]),
                        default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.clone')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_unref(UITooltip), { placement: "top" }, {
                        trigger: _withCtx(() => [
                            _createVNode(_unref(Trash01Icon), {
                                class: "w-5 h-6 text-red-400 cursor-pointer",
                                onClick: deleteElement
                            })
                        ]),
                        default: _withCtx(() => [
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.delete')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ]));
        };
    }
});
